const my_offers_tab = {
  my_available_offers: 'Mis ofertas disponibles ({{offers}})',
  offer_details: 'Detalles de la oferta',
  to_access: 'Acceder',
}


export default my_offers_tab
